/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faSquareFull, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

export enum WorkflowItemType {
  CAMERA = 'PHOTO',
  SCANNER = 'SCANNER',
  EVALUATION = 'EVALUATION',
  QUESTION = 'QUESTION',
  FORM = 'FORM',
  SIGNATURE = 'SIGNATURE',
  UNKNOWN = 'UNKNOWN'
}
export enum WorkflowItemSubtype {
  INFO = 'INFO',
  INPUT = 'INPUT',
  CHECKLIST = 'CHECKLIST',
  UNKNOWN = 'UNKNOWN'
}
export abstract class RecordBaseModel {
  itemName: string;
  itemType: WorkflowItemType;
  itemSubtype?: WorkflowItemSubtype;
  itemTitle: string;
  itemData?: any;
  itemIcon: IconDefinition = faSquareFull;
  geolocation?: LocationModel;
  timestamp?: string;

  constructor(
    itemName: string,
    itemType: WorkflowItemType,
    itemSubtype?: WorkflowItemSubtype,
    geolocation?: LocationModel,
    timestamp?: string
  ) {
    this.itemName = itemName;
    this.itemType = itemType;
    this.itemTitle = itemName;
    this.geolocation = geolocation;
    this.timestamp = timestamp;
    if (itemSubtype) this.itemSubtype = itemSubtype;
  }

  abstract fromJson(json: any): RecordBaseModel | undefined;
}

export class LocationModel {
  constructor(public latitude: number, public longitude: number) {}
  static fromJson(json: any): LocationModel | undefined {
    return json?.value?.lat && json?.value?.long
      ? new LocationModel(
          Number.parseFloat(json?.value.lat.value),
          Number.parseFloat(json?.value.long.value)
        )
      : undefined;
  }
}
export abstract class TracingModel {
  totalTravelDistance?: number;
  last_known_location?: LocationDto;

  constructor(totalTravelDistance: number) {
    this.totalTravelDistance = totalTravelDistance;
    this.last_known_location = this.last_known_location;
  }
}
export class LocationDto {
  lat: number;
  long: number;
  hor_acc?: number;
  alt?: number;
  vert_acc?: number;
  bearing?: number;
  bearing_acc?: number;
  speed?: number;
  speed_acc?: number;
  timestamp: Date;
  constructor(lat: number, long: number, timestamp: Date) {
    this.lat = lat;
    this.long = long;
    this.timestamp = timestamp;
  }
}
